import React from "react";
import { useFormattedAmount } from "../../../../hooks/useFormattedAmount";
import { ChangeValueContainer, OldValue, Arrow, NewValue, StyledItemName } from "../index.styles";

/**
 * Renders a single field change (old -> new).
 * @param {Object} props
 * @param {string} props.field - The display label of the field.
 * @param {string} props.fieldName - The raw API field name.
 * @param {string|number|null} props.oldValue - The previous value.
 * @param {string|number|null} props.newValue - The new value.
 * @param {string} props.actionType - The action type ("+", "-", "~").
 * @return {JSX.Element}
 */
export const ChangeValue = ({ field, fieldName, oldValue, newValue, actionType }) => {
  const formatAmount = useFormattedAmount();

  const isAmountOrQtyField = name => {
    if (!name) return false;
    if (name.endsWith("_type")) return false;
    return /(^|_)(qty|quantity|amount|price|cost|rate)(_|$)/i.test(name);
  };

  const formatChangeValue = (value, name, formatter) => {
    if (value === null || value === undefined || value === "") return "none";
    if (isAmountOrQtyField(name)) return formatter(value);
    return String(value);
  };

  if (actionType !== "~") return null;

  return (
    <ChangeValueContainer className="update">
      <StyledItemName>{field} </StyledItemName>
      <OldValue>{formatChangeValue(oldValue, fieldName, formatAmount)}</OldValue>
      <Arrow> {"->"} </Arrow>
      <NewValue>{formatChangeValue(newValue, fieldName, formatAmount)}</NewValue>
    </ChangeValueContainer>
  );
};
